import { api } from '~/application/api';
import type { ApplicationResult, CollectionResult } from '~/application/types';
import type { Webshop } from './types';

const webshopApi = api.enhanceEndpoints({
    addTagTypes: ['Webshop'],
}).injectEndpoints(({
    endpoints: build => ({
        createWebshop: build.mutation<ApplicationResult, Partial<Webshop>>({
            query: body => ({
                url: '/webshops',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['Webshop'],
        }),
        deleteWebshop: build.mutation<ApplicationResult, string | number>({
            query: id => ({
                url: `/webshops/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_, __, id) =>
                [{ type: 'Webshop', id }],
        }),
        listWebshops: build.query<CollectionResult<Webshop>, string>({
            query: (queryString) => `/webshops?${queryString}`,
            providesTags: result => result
                ? result.collection.map(webshop => ({ type: 'Webshop', id: webshop.id }))
                : ['Webshop'],
        }),
        updateWebshop: build.mutation<ApplicationResult, Webshop>({
            query: (body) => ({
                url: `/webshops/${body.id}`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (_, __, arg) =>
                [{ type: 'Webshop', id: arg.id }],
        }),
        webshopDetails: build.query<Webshop, number | string>({
            query: webshopId => `/webshops/${webshopId}`,
            providesTags: (_, __, arg) =>
                [{ type: 'Webshop', id: arg }],
        }),
    }),
}));

export const {
    useCreateWebshopMutation,
    useDeleteWebshopMutation,
    useListWebshopsQuery,
    useUpdateWebshopMutation,
    useWebshopDetailsQuery,
} = webshopApi;
